import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jdata(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
 <Sides/>
 <Helmet>
 
  <title>Master the Art of Java DataTypes: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Discover Java datatypes in no time! Our beginner's tutorial offers expert guidance and hands-on examples for you to master this essential programming concept." />
<meta name="keywords" content="Java datatypes, data types in Java, Java data types long, Java data types examples, CodeExampler tutorial. " />
<link rel="canonical" href="https://www.codeexampler.com/java-data-types" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Java Data Types</h1>
    <div className="first">
        <a href="/java-literals">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-operators">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   <h2 className="mt-4 ">There are three types of java datatypes:
</h2>
<h3 className="mt-4 mh2">1, Value Data Type<br/>
2, Pointer Data Type<br/>
3, Reference Data Type<br/>
</h3>
<p className="mt-4 para"><span className="bold">1, Value Data Type:</span> int,float,double,short,ushort,bool,long,char etc.<br/>
<span className="bold">2, pointer Data Type:</span> pointer<br/>
<span className="bold">3, Reference Data type:</span> object,class,interface,etc.
</p>

<h2 className="mt-4 mh2">Primitive data types are Eight types in java.</h2>
<h3 className="mt-4 mh3">1, Int<br/>
2, Float<br/>
3, double<br/>
4, Boolean<br/>
5, byte<br/>
6, Short<br/>
7, Char<br/>
8, Long<br/>
</h3>


<br/>
<h2 className="headings">Java Datatypes Example:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}          
    <span className="qwerty-2">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">10;</span>
    {"\n"}
    <span className="qwerty-6">float </span>
    <span className="qwerty-4">num</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">2348</span>
    <span className="qwerty-6">f;</span>
    {"\n"}
    <span className="qwerty-7">double </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">20.8456456;</span>
    {"\n"}
    <span className="qwerty-8">boolean </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">true;</span>
    <span className="qwerty-5"> {`// false`}</span>
    {"\n"}
    <span className="qwerty-2">byte </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">10;</span>
    {"\n"}
    <span className="qwerty-8">Short </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">10000;</span>
    {"\n"}
    <span className="qwerty-3">Char </span>
    <span className="qwerty-4">h</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">'j';</span>
    {"\n"}
    <span className="qwerty">Long </span>
    <span className="qwerty-4">h</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">10525252272544</span>
    <span className="qwerty">l;</span>
    {"\n"}


 
  {"\n"}
  {"\n"}
     </code>
      </pre>        
    </div>


<h3 >1, Integers Java data type -<br/></h3>
<p className="para mt-4">In the Integers Java data type, this group includes int, long, short, and byte, and this is a whole value number integers have positive, negative, and all kinds of signs but without decimal.<br/>
 we can store only numeric values and int data types keep from  -2147483648 to 2147483647.
</p>



<h2 className="headings">Q-Integers Java basic data types Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
      <span className="qwerty-2">&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">244565;</span>
 
  {"\n"} 
  <span className="qwerty-10">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;244565</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<h3>B, In long Java data type:</h3>
<p className="mt-4 para">
The long data type is used when int can't handle significant value, so the long data type in java store value start from -9223372036854775808 and on 9223372036854775807<br/>
 you don't store the considerable value inside long data type if you type long data type, so you also write capital l like" l" after number end.
</p>



<h2 className="headings">long Java basic data types Example :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}
    <span className="qwerty">&nbsp;Long </span>
    <span className="qwerty-4">h</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">10525252272544</span>
    <span className="qwerty">l;</span>
    {"\n"} 
  <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">h</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
      <span className="qwerty-10">&nbsp;156</span> 
      <span className="qwerty-3"> is an int </span> 
      {"\n"}
      <span className="qwerty-10">&nbsp;156</span> 
      <span className="qwerty">l</span>
      <span className="qwerty-3"> is an Long </span> 
      {"\n"}{"\n"}
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-1">&nbsp;10525252272544</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<br/>


<h3>C, In Short Java data type:</h3>
<p className="mt-4 para">

Short Java data type is used when creates a short integer, and quick data type stores whole numbers from -32768 to 32767 And short is used when you don't need the large range number like int.
</p>


<h2 className="headings">Short Java basic data types Example :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}
    <span className="qwerty-8">&nbsp;Short </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">32765;</span>
    {"\n"}
  <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;32765</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>
    

<h3>D,In Byte Java data type:</h3>
<p className="mt-4 para">
Byte Java data type is used when the minor integer type is a byte in integer .byte can store numbers from -128 to 127.
</p>
<h2 className="mt-4 mh2">2, Characters Java data type</h2>
<p className="mt-4 para" >a, Char Java data type is used to hold a single character, Unicode character. <br/>
b, Char data type enclosed by a single quotes .
</p>


<h2 className="headings">Char Java basic data types Example :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}
    <span className="qwerty-3">&nbsp;Char </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">'h';</span>
    {"\n"}
    <span className="qwerty-3">&nbsp;Char </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">88;</span>
    <span className="qwerty-5">{`//code for x learn by unicode`}</span>
    {"\n"}
  <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;h</span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;X</span>          
          {"\n"} 
       
            </code>{"   "}
            </pre>
      </div>
    </div>

<br/>

<h2 className="headings">Char Java another data types Example :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}   
        <span className="qwerty-3">&nbsp;Char </span>
        <span className="qwerty-4">a</span>
        <span className="qwerty">,</span>
        <span className="qwerty-4">b;</span>
        {"\n"}    
    <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">'x';</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">90;</span>
    {"\n"}
  <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;x</span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;Z</span>          
          {"\n"} 
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">If you increment character in Java basic data types:
</h2>

<br/>

<h2 className="headings">Char Java basic data types Example :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}   
        <span className="qwerty-10">Char </span>
        <span className="qwerty-4">a;</span>
        {"\n"}    
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">'x';</span>
    {"\n"}
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
      <span className="qwerty-4">a</span>
      <span className="qwerty-8">++;</span>
      <span className="qwerty-5">{`// increment a`}</span>
      {"\n"}
      <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      {"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;x</span>          
          {"\n"} 
          <span className="qwerty-3">&nbsp;y</span>          
          {"\n"} 
       
            </code>{"   "}
            </pre>
      </div>
    </div>
    


<h2 className="mt-4 mh2">3, Floating-point Java data type</h2>
<p className="mt-4 para">1, In the Floating point, data types include Float and double and show a number with a fraction.<br/>
2, These floating-point numbers is a natural number<br/>
 <span className="bold ">Floating points in java are two types:<br/>1, Float <br/>2, Double </span><br/>
*double bits is 64<br/>
*float bits is 32<br/>
</p>

<p className="mt-4 para">
<span className="bold">A, In Float Java data type:</span><br/>
1, Float specifies a single-precision value means uses 32bits of storage. <br/>
2, This Float is slower than double precision, but it takes half as much space as double-precision <br/>
3, The float stores a fractional number from 3.4e−038 to 3.4e+038.<br/>
4, Float used for representing dollars and cents<br/>
5, You don’t store float value inside float data type if you type Float data type, so you also write small f like "f" after number end. <br/>
</p>



<h2 className="headings">Float Java basic data types Example :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}
    <span className="qwerty-10">float </span>
    <span className="qwerty-4">number</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40.56</span>
    <span className="qwerty-6">f;</span>
    {"\n"}
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">number</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;40.56</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<p className="mt-4 para">
<span className="bold">B, In Double Java data type:<br/></span>
1, double specifies a double-precision value means uses 64 bits of storage.<br/> 
2, double precision is faster than single precision<br/>
3, the double stores' fractional number 1.7e−308 to 1.7e+308<br/>
4, you don’t store the double value inside double data type if you type double data type, so you also write small d like "d" after number end.<br/>
</p>


<h2 className="headings">Double Java basic data types Example :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}
    <span className="qwerty-10">double </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">12.426</span>
    <span className="qwerty-7">d;</span>
    {"\n"}
    <span className="qwerty-5">OR</span>
    {"\n"}
    <span className="qwerty-10">double </span>
    <span className="qwerty-4">a;</span>
    {"\n"}
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">12.426</span>
    <span className="qwerty-7">d;</span>
    {"\n"}
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;12.426</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">4, Bool Java data type:</h2>

<p className="mt-4 para">
The Boolean Java data type group includes Boolean, and this shows only true or false values and uses the reserved word true and false.
</p>



<h2 className="headings">Bool Java basic data types Example:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}          
    <span className="qwerty-5">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">4;</span>
    {"\n"}         
    <span className="qwerty-5">int </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">8;</span>
    {"\n"}
    <span className="qwerty-8">boolean </span>
    <span className="qwerty-4">c</span>
    <span className="qwerty">=</span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">&#60;</span>
    <span className="qwerty-4">b;</span>
    {"\n"}
  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">c</span>
      <span className="qwerty-1">);</span>
      {"\n"}{"\n"}
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;true</span>          
          {"\n"} 
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>
    


  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/java-literals">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-operators">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jdata;